import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const WarengruppenServiceConfig = {
  name: "Warengruppen",
  annotations: []
} as ServiceConfig;